<app-uni-dialog  [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <app-ag-grid class="mt-3" [gridOptions]="mainGridOptions" [rowData]="allItems" > </app-ag-grid>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2 mt-3">
    <button pButton type="button" class="p-button-raised" [disabled]="selectedItem == null"  (click)="ok()">Ok
    </button>
    <button pButton type="button" class="p-button-raised" (click)="cancel()">Cancel
    </button>
  </div>
  
</ng-template>
